// pages/layout/PublicLayout.tsx
import React from "react";
import HeaderMain from "../components/HeaderMain";
import Footer from "../components/Footer"; // assuming you have a Footer component
import { Outlet } from "react-router-dom";

const PublicLayout: React.FC = () => {
  return (
    <>
      <HeaderMain />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default PublicLayout;
